import {
  MixedModelConstructed,
  MixedModelConstructedNoDates,
} from "@/types/types";

export const createMixedModelName = (
  mixedModelConstructed: MixedModelConstructedNoDates | MixedModelConstructed
) => {
  const model1Name = mixedModelConstructed.model1Name;
  const model2Name = mixedModelConstructed.model2Name;
  const model3Name = mixedModelConstructed.model3Name;
  const model4Name = mixedModelConstructed.model4Name;

  const model1Percentage = mixedModelConstructed.model1Percentage;
  const model2Percentage = mixedModelConstructed.model2Percentage;
  const model3Percentage = mixedModelConstructed.model3Percentage;
  const model4Percentage = mixedModelConstructed.model4Percentage;

  let returnValue = `${model1Percentage}% ${model1Name} ${model2Percentage}% ${model2Name}`;
  if (model3Name !== null && model3Name !== "") {
    returnValue += ` ${model3Percentage}% ${model3Name}`;
  }
  if (model4Name !== null && model4Name !== "") {
    returnValue += ` ${model4Percentage}% ${model4Name}`;
  }

  return returnValue;
};
